import React, { useState, useEffect, useCallback, useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './Test.module.scss';
import Loading from '../../components/Spin/Loading';
import axios from 'axios';

const cx = classNames.bind(styles);

function Test() {
    const [loading, setLoading] = useState(false);

    return <div className="p-4 bg-blue-500 text-white rounded-md">Tailwind hoạt động!</div>;
}

export default Test;
